<div class="pb-lg gap-lg grid">
  <p class="text-content-secondary">
    Vous pouvez retirer des aptitudes, ainsi que des interrelations et des productions. Les aptitudes visibles ici sont
    celles qui ont été ajoutées au module. Une aptitude, interrelation & production minimum.
  </p>

  <div class="gap-xxs grid">
    <label hlmLabel for="select-aptitude">Aptitudes</label>
    <hlm-autocomplete
      [(ngModel)]="nouvelleAptitude"
      [id]="'autocomplete-aptitude'"
      [filteredOptions]="aptitudesFiltrees()"
      (searchChange)="filterAptitudes($event)"
      placeholder="Rechercher une aptitude du module"
      autocompleteSearchClass="border-stroke-neutral-medium"
    />
  </div>

  @for (control of objectifs.controls; track $index; let idx = $index) {
    <app-sequence-objectif-group
      [index]="idx"
      [form]="control"
      [module]="module()"
      (supprimerAptitude)="supprimerAptitude(idx)"
    />
  }
</div>
